// 可拖的數字（像 After Effects）：游標放在數字上左右拖就改值。純計算，有測試。

export const SCRUB_THRESHOLD_PX = 3;
export const SCRUB_MAX_SEC = 3600;

/** 從 start 拖了 dx 像素 → 新的秒數：一般每 2 像素 0.1 秒，Shift 每像素 0.5 秒；夾在 0 到 3600 */
export function scrubSeconds(start: number, dx: number, coarse = false): number {
  const raw = start + dx * (coarse ? 0.5 : 0.05);
  const stepped = Math.round(raw * 10) / 10;
  return Math.max(0, Math.min(SCRUB_MAX_SEC, stepped));
}

/** 機關位置（公尺 / 度）：從 start 拖了 dx 像素 → 新的值。一般 300 像素走完整個行程，Shift 快 5 倍；夾在行程內、取到 dec 位 */
export function scrubRange(start: number, dx: number, min: number, max: number, dec: number, coarse = false): number {
  const raw = start + dx * ((max - min) / 300) * (coarse ? 5 : 1);
  const f = 10 ** dec;
  return Math.max(min, Math.min(max, Math.round(raw * f) / f));
}
